export const personalization_groups = Object.freeze([
    {
        id: 33,
        name: "Дериваты",
        code: "004",
        categories: [
            {
                key: "personalization",
                fields: [
                    {
                        labelRu: "Длина рога (в см)",
                        labelKz: "Мүйіз ұзындығы (см)",
                        value: "hornLengthCm"
                    }, 
                    {
                        labelRu: "Сорт рога",
                        labelKz: "",
                        value: "sort",
                        isSelector: true,
                        options: [
                            { label: "1", value: "1" },
                            { label: "2", value: "2" },
                            { label: "3", value: "3" },
                            { label: "4", value: "4" }
                        ]
                    },
                    {
                        labelRu: "Источник происхождения",
                        labelKz: "",
                        value: "sourceCode",
                        isSelector: true,
                        options: []
                    },
                    {
                        labelRu: "Дата изъятия",
                        labelKz: "Алып қою күні",
                        value: "extractionDate",
                        auto: true,
                        autoSource: "documentCreatedAt"
                    },
                    {
                        labelRu: "Сотрудник",
                        labelKz: "Қызметкер",
                        value: "employee",
                        auto: true,
                        autoSource: "currentUser"
                    },
                ],
            },
        ],
    },
    {
        id: 24,
        name: "Ювелирные изделия",
        code: "001",
        categories: [
            {
                key: "personalization",
                fields: [
                    {
                        labelRu: "Вес, г",
                        labelKz: "Салмақ, г",
                        value: "weight"
                    },
                    {
                        labelRu: "Размер, мм",
                        labelKz: "Өлшем, мм",
                        value: "size"
                    },
                ],
            },
        ],
    },
    {
        id: 32,
        name: "Сжиженный нефтяной газ",
        code: "003",
        categories: [
            {
                key: "personalization",
                fields: [
                    {
                        labelRu: "Объем газа (в литрах)",
                        labelKz: "Газ көлемі (литрмен)",
                        value: "gasVolume"
                    },
                    {
                        labelRu: "Уникальный код баллона(на металлической бирке)",
                        labelKz: "ГБ түгендеу нөмірі",
                        value: "gasCylinderId",
                    },
                    {
                        labelRu: "Дата заполнения баллона",
                        labelKz: "Баллонды толтыру күні",
                        value: "fillingDate",
                        auto: true,
                        autoSource: "documentCreatedAt"
                    },
                ],
            },
        ],
    },
    {
        id: 68,
        name: "Древесина",
        code: "002",
        categories: [
            {
                key: "personalization",
                fields: [
                    {
                        labelRu: "Тип древесины",
                        labelKz: "Сүрек түрі",
                        value: "woodType",
                        isSelector: true,
                        // label — русская подпись (используется в форме персонализации), labelKz — для казахского интерфейса
                        options: [
                            { label: "Деловая", labelKz: "Іскерлік", value: "1" },
                            { label: "Дровяная", labelKz: "Отындық", value: "2" },
                        ]
                    },
                    {
                        labelRu: "Порода древесины",
                        labelKz: "Сүрек тұқымы",
                        value: "woodSpecies",
                        isSelector: true,
                        options: [
                            { label: "Хвойная", labelKz: "Қылқан жапырақты", value: "1" },
                            { label: "Лиственная", labelKz: "Жапырақты", value: "2" },
                        ]
                    },
                    {
                        labelRu: "Номер билета",
                        labelKz: "Билет нөмірі",
                        value: "ticketNumber"
                    },
                    {
                        labelRu: "Объем леса (в м3)",
                        labelKz: "Ағаш көлемі (м3)",
                        value: "forestVolume"
                    },
                    {
                        labelRu: "Дата изготовления",
                        labelKz: "Жасалған күні",
                        value: "manufactureDate",
                        auto: true,
                        autoSource: "documentCreatedAt"
                    },
                ],
            },
        ],
    },
]);

